import { render, staticRenderFns } from "./kdxCopyText.g.vue?vue&type=template&id=24f87a2e&scoped=true"
import script from "./kdxCopyText.g.vue?vue&type=script&lang=js"
export * from "./kdxCopyText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxCopyText.g.vue?vue&type=style&index=0&id=24f87a2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f87a2e",
  null
  
)

export default component.exports